import { landmineNames } from '@mm/constants/landmine-names';
import { useTwilioCRUDActions } from '@mm/state/actions/TwilioCRUDActions';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import {
  combinedFeatureFlagsSelector,
  companyFeatureFlagsSelector,
} from '@mm/state/selectors/featureFlagsSelectors';
import {
  hasDeactivatedNumberSelector,
  hasSMSNumberSelector,
  recentDiscardedSelector,
  twillioNumberSelector,
} from '@mm/state/selectors/twillio';
import {
  activeFacebookPageIdSelector,
  getTwilioAvailable,
} from '@mm/state/selectors/viewSelectors';
import { useSelector } from 'react-redux';

// TODO re-use this hook in chat blasters & drip-campaign as it has shared logic
export const usePhoneNumber = () => {
  const twilioFeatFlag = useSelector(companyFeatureFlagsSelector).twilio;
  const hasActivateNumberFlag = useSelector(
    combinedFeatureFlagsSelector,
  ).smsActivateNumber;

  const twilioAvailableFlag = useSelector(getTwilioAvailable);
  const isSmsSupported = twilioFeatFlag || twilioAvailableFlag;
  const hasNumber = useSelector(hasSMSNumberSelector);
  const twilioNumber = useSelector(twillioNumberSelector);
  const hasDeactivatedNumber = useSelector(hasDeactivatedNumberSelector);
  const { activatePage } = useTwilioCRUDActions();
  const facebookPageId = useSelector(activeFacebookPageIdSelector);
  const recentDiscardedNumber = useSelector(recentDiscardedSelector);
  const { openUniversalUpgradeLandmineModal, openActivateSMSNumberModal } =
    useModalActions();

  const performActivationViaModal =
    (onSuccessActivateNumber?: () => void) => async () => {
      if (hasDeactivatedNumber) {
        activatePage(facebookPageId, true, {
          numberKind: 'twilio',
          number: recentDiscardedNumber,
        });
        openActivateSMSNumberModal({
          onSuccessActivateNumber,
        });
        return;
      }

      if (!hasActivateNumberFlag) {
        openUniversalUpgradeLandmineModal({
          feature: 'smsActivateNumber',
          landmineName: landmineNames['SMS-ACTIVATE-NUMBER'],
        });
        return;
      }
      openActivateSMSNumberModal({
        onSuccessActivateNumber,
      });
    };

  return {
    isSmsSupported,
    hasNumber,
    phoneNumber: twilioNumber,
    performActivationViaModal,
  };
};
